import { Link, usePage } from "@inertiajs/react"
import { PublicHero, PublicShell } from "@/components/PublicShell"
import { AccountPromptCard } from "@/components/public/AccountPromptCard"
import { PublicMeta } from "@/components/public/PublicMeta"
import { Button } from "@/components/ui/button"
import type { PageProps } from "@/types/inertia"

const TITLE = "Thank You for Your Enquiry"
const DESCRIPTION =
  "Your enquiry has reached SOH GD Wines. We will be in touch personally to talk through the wines, your label and delivery."

type ThankYouProps = {
  // The new enquiry, set once by EnquiriesController#create (M7); null on a
  // revisit or after the honeypot.
  enquiry_id: number | null
}

export default function ContactThankYou() {
  const { props } = usePage<PageProps<ThankYouProps>>()
  const enquiryId = props.enquiry_id ?? null

  return (
    <PublicShell>
      <PublicMeta title={TITLE} description={DESCRIPTION} />

      <PublicHero
        eyebrow="Enquiry received"
        title={
          <>
            Thank you. <span className="soft">We will be in touch.</span>
          </>
        }
        lede="Your enquiry is with us, and a copy is on its way to your inbox. We will contact you personally to talk through the wines, your label and delivery."
        actions={
          <>
            <Button asChild variant="gold" size="lg">
              <Link href="/wines">View Our Wines</Link>
            </Button>
            <Button asChild variant="ghost-hairline" size="lg">
              <Link href="/">Return Home</Link>
            </Button>
          </>
        }
      />

      {/* The same account card as the order thank-you (M6). Signed in, it goes
          straight to the new enquiry (M7); on a revisit, to the list, where
          the newest enquiry is first. */}
      <section className="band band-charcoal pt-0" aria-label="Follow your enquiry">
        <div className="shell">
          <div className="max-w-[560px]">
            <AccountPromptCard
              noun="enquiry"
              titleId="contact-account-title"
              trackHref={enquiryId ? `/account/orders/${enquiryId}` : "/account/orders"}
            />
          </div>
        </div>
      </section>
    </PublicShell>
  )
}
